module.exports = __webpack_public_path__ + "static/media/CTA4.6e5381f7.avif";